import React from 'react';
import { Notification } from "rbx";
import { Link } from "react-router-dom";
import UserService from '../../../services/user';
import { unMask } from '../../../commons/masks';
import Controls from '../../components/Controls/Controls';
import useForm from '../../components/useForm';

function ActiveForm() {
  const {
    values,
    status,
    setStatus,
    stateButton,
    setStateButton,
    handleInputChange
  } = useForm( {cpf_cnpj: '', password: '', releaseCode: ''} );

  const handleSubmit = async (event) => {
    event.preventDefault();
    setStateButton("loading");
    try {
      const response = await UserService.activate({...values, cpf_cnpj: unMask(values.cpf_cnpj)});
      setStatus(['success', `${response.status}: Ativação realizada com sucesso.`]);
    } catch(e) {
      if (e.response)
        if (e.response.data.errors)
          setStatus(['danger', `${e.response.status}: ${e.response.data.errors}`]);
        else
          setStatus(['danger', `${e.response.status}: ${e.response.data.message}`]);
      else
        setStatus(['danger', `${e.message}`]);
    }
    setStateButton("")
  }

  return (
    <form onSubmit={e => handleSubmit(e)}>
        { status!=='' && <Notification color={status[0]}>{status[1]}</Notification> }
        <Controls.CpfCnpjField 
          label="CPF ou CNPJ:"
          name="cpf_cnpj"
          placeholder='123.456.789-01'
          value={values.cpf_cnpj}
          onChange={handleInputChange}
          focus={true}
          required
        />
        <Controls.TextField 
          label="Código:"
          name="code"
          placeholder='1A2B3C'
          value={values.code}
          onChange={handleInputChange}
          maxLength="8"
          required
        />
        <Controls.PasswordField 
          label="Senha:"
          name="password"
          value={values.password}
          onChange={handleInputChange}
          required
        />
        <Controls.ActionButton 
          buttonState={stateButton}
          buttonName='Ativar'
          color='custom-purple'
          className='is-fullwidth is-medium'
        />
        <Link to="/login">Entrar</Link>
    </form>
  )
}

export default ActiveForm;
